module.exports = __webpack_public_path__ + "img/logo.36e05fc6.svg";